export default {
  getSchema: state => state.schema,
  getInitialSchema: state => state.initialSchema,
  getPages: state => state.pages,
  getModes: state => state.modes,
  getTypeOfPageEditing: state => state.typeOfPageEditing,
  getConfirmPageChanges: state => state.confirmPageChanges,
  getSelected: state => state.selected,
  getSelectedTab: state => state.selectedTab,
  getActiveTab: state => state.activeTab,
  getConfigLayout: state => state.configLayout,
  getCurrentMode: state => state.currentMode,
  getCurrentTemplate: state => state.currentTemplate,
  getNavItems: state => state.navItems,
  getSelectedPortal: state => state.selectedPortal,
  getSelectedEnvironment: state => state.selectedEnvironment,
  getSelectedPage: state => state.selectedPage,
  getSelectedItem: state => state.selectedItem,
  getParents: state => state.parents
};
